import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useLocale } from '../contexts/LocaleContext'
import { getPlatform } from '../constants/stores'
import StoreBadges from './StoreBadges'
import DownloadQR from './DownloadQR'

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } })
}

function Hero() {
  const { t } = useLocale()
  const [platform] = useState(getPlatform)

  return (
    <section className="hero" id="download">
      <div className="container hero-grid">
        <motion.div initial="hidden" animate="visible">
          <motion.div className="eyebrow" variants={fadeUp} custom={0}>
            <span className="eyebrow-dot" aria-hidden="true" />
            {t.hero.eyebrow}
          </motion.div>
          <motion.h1 variants={fadeUp} custom={1}>
            {t.hero.titleStart} <span className="gradient-text">{t.hero.titleHighlight}</span>
          </motion.h1>
          <motion.p className="subtitle" variants={fadeUp} custom={2}>{t.hero.subtitle}</motion.p>
          <motion.div className="hero-download" variants={fadeUp} custom={3}>
            <StoreBadges />
            {platform === 'desktop' && <DownloadQR />}
          </motion.div>
          <motion.ul className="hero-perks" variants={fadeUp} custom={4}>
            {t.hero.perks.map((perk) => (
              <li key={perk}>{perk}</li>
            ))}
          </motion.ul>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.92, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero-glow" aria-hidden="true" />
          <motion.img
            src="/assets/simulator_home.png"
            alt="Gym Journey app showing workout logging and progress graphs"
            width="300"
            height="500"
            fetchpriority="high"
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="hero-chip hero-chip--pr"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.9, duration: 0.5 }}
            aria-hidden="true"
          >
            <span className="hero-chip-icon">🏆</span>
            <span>
              <strong>{t.hero.chipPrTitle}</strong>
              <small>{t.hero.chipPrSubtitle}</small>
            </span>
          </motion.div>
          <motion.div
            className="hero-chip hero-chip--streak"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.1, duration: 0.5 }}
            aria-hidden="true"
          >
            <span className="hero-chip-icon">📈</span>
            <span>
              <strong>{t.hero.chipProgressTitle}</strong>
              <small>{t.hero.chipProgressSubtitle}</small>
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default Hero
